import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { push } from 'connected-react-router';

import { notification } from '../../../actionTypes';
import { userTypes } from '../../../utils/constants';
import { formatPath } from '../../../utils/textFormaters';
import { downloadPqfDocument } from '../../../utils/pqfPdf';
import routes from '../../routes/path';

const PqfDocumentDownload = () => {
  const dispatch = useDispatch();
  const { companyId, pqfId } = useParams();

  const userId = useSelector(state => state.auth.check.userId);
  const { companyType } = useSelector(state => state.entity.user[userId] || {});

  useEffect(() => {
    const downloadAndRedirect = async () => {
      try {
        await downloadPqfDocument({ companyId, pqfId });
      } catch (e) {
        dispatch({ type: notification.add, payload: { error: e.message } });
      }

      const relocationPath =
        companyType === userTypes.Contractor
          ? routes.private.index
          : formatPath(routes.private.company.id, { id: companyId });

      dispatch(push(relocationPath));
    };

    downloadAndRedirect();
  }, [companyId, companyType, dispatch, pqfId]);

  return '';
};

export default PqfDocumentDownload;
